import React, { memo, useState } from "react"
import { Button, Card, CardBody, Col, Form, Input, Row } from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup"
import { useDispatch, useSelector } from "react-redux"

import LeftSide from "./LeftSide"
import RightSide from "./RightSide"
import AttendanceAction from "store/attendance-resource/actions"
import { useHistory } from "react-router-dom"
import { toast } from "react-toastify"

const TabEngraving = () => {
  const dispatch = useDispatch()
  const [isUpdate, setIsUpdate] = useState(false)
  const history = useHistory()
  const [isModal, setIsModal] = React.useState(false)
  const [totalWorkError, setTotalWorkError] = React.useState("")

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      remarks: "",
      totalHour: 0,
      totalMinute: 0,
      inspectionHour: 0,
      inspectionMinute: 0,
      assignments: [
        {
          assignmentId: 0,
          hour: 0,
          minute: 60,
        },
      ],
      otherWorks: [
        {
          otherWorkId: "",
          hour: 0,
          otherWorkName: "",
          minute: 0,
        },
      ],
    },
    validationSchema: Yup.object({
      totalHour: Yup.string().required("必須項目です。"),
      totalMinute: Yup.string().required("必須項目です。"),
      inspectionHour: Yup.number(),
      inspectionMinute: Yup.number(),
      assignments: Yup.array().of(
        Yup.object({
          assignmentId: Yup.number().required("必須項目です。"),
          hour: Yup.number().min(0).required("必須項目です。"),
          minute: Yup.number().min(0).max(60).required("必須項目です。"),
        })
      ),
      otherWorks: Yup.array().of(
        Yup.object({
          otherWorkId: Yup.number().when(["hour", "minute"], (hour, minute) => {
            if (hour > 0 || minute > 0) {
              return Yup.number().required("必須項目です。")
            }
          }),
          hour: Yup.number().min(0).required("必須項目です。"),
          minute: Yup.number().min(0).max(60).required("必須項目です。"),
        })
      ),
    }),
    onSubmit: values => {
      let totalHour = values.assignments
        .filter(i => i.checked)
        .map(i => Number(i.hour))
        .reduce((a, b) => a + b, 0)
      let totalMinute = values.assignments
        .filter(i => i.checked)
        .map(i => Number(i.minute))
        .reduce((a, b) => a + b, 0)

      if (totalMinute >= 60) {
        let tempHour = Number(String(totalMinute / 60).split(".")[0])
        let tempMinute = tempHour * 60
        totalMinute -= tempMinute
        totalHour += tempHour
      }

      let otherWorkHour = values.otherWorks
        .map(i => Number(i.hour))
        .reduce((a, b) => a + b, 0)
      let otherWorkMinute = values.otherWorks
        .map(i => Number(i.minute))
        .reduce((a, b) => a + b, 0)

      if (otherWorkMinute >= 60) {
        let tempHour = Number(String(otherWorkMinute / 60).split(".")[0])
        let tempMinute = tempHour * 60
        otherWorkMinute -= tempMinute
        otherWorkHour += tempHour
      }

      totalMinute =
        totalMinute + otherWorkMinute + Number(values.inspectionMinute)
      totalHour = totalHour + otherWorkHour + Number(values.inspectionHour)

      if (totalMinute >= 60) {
        let tempHour = Number(String(totalMinute / 60).split(".")[0])
        let tempMinute = tempHour * 60
        totalMinute -= tempMinute
        totalHour += tempHour
      }

      values.totalHour = totalHour
      values.totalMinute = totalMinute
      if (values.totalHour >= 8) {
        dispatch(AttendanceAction.postClockOut(values))
        setIsUpdate(true)
      } else {
        setIsModal(true)
      }
    },
  })

  const clockOutCallback = () => {
    history.push("/")
  }
  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        validation.handleSubmit()
        return false
      }}
    >
      <Row>
        <Card>
          <CardBody>
            <LeftSide
              validation={validation}
              isModal={isModal}
              setIsModal={setIsModal}
              isUpdate={isUpdate}
              setIsUpdate={setIsUpdate}
            />
          </CardBody>
        </Card>
        <RightSide validation={validation} />
      </Row>
    </Form>
  )
}

export default memo(TabEngraving)
